import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';

import I18n from 'PMT/i18n/I18n';
import { Utils } from 'PMT/utils';

import Constants from 'constants/Constants'

import {
  MenuPart,
  RestaurantMenu
} from 'PMT/entities/menu';

import { TextInput, TextInputLocalized, NumberInput } from 'PMT/components/form';
import AbstractFormComponent from 'components/form/AbstractFormComponent';

/**
 */
export default class MenuPartForm extends AbstractFormComponent {

  static defaultProps = {
    menuPart: new MenuPart()
  };

  static propTypes = {
    restaurantMenu: PropTypes.objectOf(RestaurantMenu).isRequired,

    isEditMode: PropTypes.bool.isRequired,

    menuManagedByPos: PropTypes.bool,

    menuPart: PropTypes.objectOf(MenuPart),

    /**
     * @param MenuPart
     */
    onUpdate: PropTypes.func.isRequired,

    /**
     * @param MenuPart
     */
    onDelete: PropTypes.func
  };

  state = this.getDefaultState();

  get menuPart(): MenuPart {
    return this.state.menuPart;
  }

  onSubmit = () => {
    const menuPart = this.state.menuPart;

    if (!menuPart.isValidToCreate()) {
      this.setState({
        validationErrors: menuPart.getValidationErrors()
      });
    } else {
      if (!this.props.isEditMode) {
        menuPart.id = Utils.generateUID();
      }
      this.props.onUpdate(menuPart);
    }
  };

  onMenuPartChange = (menuPart: MenuPart) => {
    this.setState({
      menuPart,
      validationErrors: menuPart.getValidationErrors()
    });
  };

  //
  // AbstractFormComponent
  //

  haveModifications(): boolean {
    return !this.props.menuPart.equals(this.state.menuPart);
  }

  getDefaultState() {
    return {
      menuPart: this.props.menuPart.copy(),

      validationErrors: {}
    };
  }

  shouldDisableSubmit(): boolean {
    return !this.state.menuPart.isValidToCreate();
  }

  //
  // Form events
  //

  onNameChange = (newValue: string) => {
    const menuPart: MenuPart = this.menuPart;
    menuPart.localizedNames = newValue;
    this.onMenuPartChange(menuPart);
  };

  onMinChange = (min: number) => {
    const menuPart: MenuPart = this.menuPart;
    menuPart.min = min;
    this.onMenuPartChange(menuPart);
  };

  onMaxChange = (max: number) => {
    const menuPart: MenuPart = this.menuPart;
    menuPart.max = max;
    this.onMenuPartChange(menuPart);
  };

  onAdditionalPriceChange = (additionalPrice: number) => {
    const menuPart: MenuPart = this.menuPart;
    menuPart.additionalPrice = additionalPrice;
    this.onMenuPartChange(menuPart);
  };

  //
  // renderers
  //

  renderName() {
    return (
      <div className="form-group">
        <div className="required col-xs-4 control-label">
          <label>
            {I18n.tr('menu.menu_edit.part.form.name')}
          </label>
        </div>
        <div className="col-xs-6">
          <TextInputLocalized
            locales={Constants.localesForTranslation}
            values={this.menuPart.localizedNames}
            isRequired
            className="form-control"
            placeholder={I18n.tr('menu.menu_edit.name')}
            onChange={this.onNameChange}
          />
        </div>
        <div className="form_error col-xs-6 col-xs-offset-4">
          {this.state.validationErrors.name}
        </div>
      </div>
    );
  }

  renderMinMax() {
    if (this.props.menuManagedByPos) {
      return (null);
    }
    
    return (
      <div className="row form-group">
        <div className="col-xs-4 control-label">
          <label>
            {I18n.tr('menu.menu_edit.part.form.quantities')}
          </label>
        </div>

        <div className="col-xs-3">
          <div className="input-group">
            <NumberInput
              value={this.menuPart.min}
              onChange={this.onMinChange}
              max={this.menuPart.max}
              min={0}
            />
            <div className="input-group-addon">
              {I18n.tr('menu.menu_edit.part.form.min')}
            </div>
          </div>
        </div>
        <div className="col-xs-3">
          <div className="input-group">
            <NumberInput
              value={this.menuPart.max}
              onChange={this.onMaxChange}
              min={this.menuPart.min}
              max={99}
            />
            <div className="input-group-addon">
              {I18n.tr('menu.menu_edit.part.form.max')}
            </div>
          </div>
        </div>
        <div className="form_error col-xs-6 col-xs-offset-4">
          {this.state.validationErrors.min}
          {this.state.validationErrors.max}
        </div>
      </div>
    );
  }

  render() {
    return (
      <form
        className="form form-horizontal menu_part_form"
        role="form"
        noValidate
      >
        {this.renderName()}
        {this.renderMinMax()}

        {this.renderButtons()}
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/pages/menu/menuEdit/components/menuPartFormModal/MenuPartForm.js